const links = {
  LINKS: {
    eventMenus: "/menus",
    beverages: "/inventoryItems?Type=Beverages",
    rentals: "/inventoryItems",
    miscellaneous: "/inventoryItems?Type=miscellaneous",
    rooms: "/inventoryItems?Type=rooms",
    eventStaff: "/staff",
    financials: "/financials",
    eventInfo: "/eventInfo",
  },
};
export default links;
